import styled, { keyframes } from 'styled-components';

export const Header = styled.div`
    display: ${(props) => props.display};
    justify-content: start;
    margin-top: 50px;
    margin-left: 80px;
    overflow: none;
`;
export const HeaderContainer = styled.div`
    width: 314px;
    height: 476px;
    background-color: #000000;
    border: 1px solid #1b1b1b;
    box-shadow: 0px 8px 30px #000000;
    border-radius: 15px;
    border-bottom: 1px solid white;
    overflow: none;
`;

export const HeaderImg = styled.div`
    display: flex;
    margin-top: 20px;
    overflow: none;
    img {
        width: 150px;
        clip-path: circle(75px);
    }
`;

export const HeaderContainerInfosUl = styled.ul`
    display: grid;
    margin-top: 1px;
    justify-content: start;
    list-style-type: none;
    padding: 20px;
    border-bottom: 1px solid white;
    
    &:nth-child(6) {
        border-bottom: none;
    }
`;

export const HeaderContainerInfosLi = styled.li`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: white;
`;

export const HeaderEspecs = styled.div`
    display: ${(props) => props.display};
    overflow: none;
`;

export const HeaderEspecsContainer = styled.div`
    margin-top: -475px;
    margin-left: 30pc;
    padding-left: 700px;
    width: 300px;
    height: 230px;
    background-color: #000000;
    border: 1px solid #1b1b1b;
    box-shadow: 0px 8px 30px #000000;
    border-radius: 15px;
`;

export const HeaderEspecsUl = styled.ul`
    list-style-type: none;
    display: flex;
    gap: 20px;
    margin-left: -700px;
    margin-top: 15px;
`;

export const ReactKeyFrames = keyframes`

from {
    transform: rotate(0deg);
}

to {
    transform: rotate(360deg);
}
`;

export const HeaderEspecsLiReact = styled.li`
    img {
        display: flex;
        animation: ${ReactKeyFrames} 2s linear infinite;
        width: 40px;
    }
`;
export const HeaderEspecsLi = styled.li`
    img {
        display: flex;
        width: 40px;
    }
`;

export const EstatiscasKeyFrames = keyframes`
    5% {
       
        background-color: ${(props) => props.backgroundColor}   ;  
        height: 0%
    }
    10%{
        background-color: ${(props) => props.backgroundColor}   ;  
        height: 15%
    }
`;
export const HeaderEspecsEstatiscas = styled.div`
    display: flex;
    margin-top: 10px;
    width: 26px;
    height: 138px;
    background-color: ${(props) => props.backgroundColor};
    animation: ${EstatiscasKeyFrames} 22s linear infinite;
    box-shadow: 0px 8px 30px ${(props) => props.color};
    border: 1px solid ${(props) => props.color};
`;

export const HeaderEspecsEstatiscasH5 = styled.h5`
    display: grid;
    justify-content: center;
    margin-left: -30px;
    margin-top: 50px;
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: ${(props) => props.color};
`;

//
